var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrustedsvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.918,79.3C34.918,79.3 65.837,63.837 65.837,40.648L65.837,13.594L34.918,2L4,13.594L4,40.648C4,63.837 34.918,79.3 34.918,79.3Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(248,255,53)",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0577514,0,0,0.0577514,17.1341,24.8642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M504.502,75.496C494.505,65.498 478.297,65.498 468.298,75.496L161.594,382.203L43.702,264.311C33.705,254.313 17.497,254.314 7.498,264.311C-2.5,274.308 -2.5,290.516 7.498,300.514L143.492,436.506C153.486,446.503 169.706,446.496 179.696,436.506L504.502,111.7C514.5,101.703 514.499,85.494 504.502,75.496Z",
    style: {
      fill: "rgb(248,255,53)",
      fillRule: "nonzero"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustedsvg);
export default __webpack_public_path__ + "static/media/trustedsvg.37f99eb114ac8dd6e15724e7c9a143e7.svg";
export { ForwardRef as ReactComponent };